// Logs & Auditoría — vista del PROPIETARIO (owner) de su propio catálogo.
//
// Muestra la trazabilidad de todos los procesos pero ACOTADA al tenant del
// usuario (el backend la fija con el tenant del actor; nunca se pide del
// cliente). Reutiliza la lista de actividad compartida, sin columna de tenant
// (todo es de la misma cuenta). Consume `GET /logs`.

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useApi } from '../api/ApiContext.js';
import { PageHeader } from '../ui/components.js';
import { ActivityLogList, type ActivityLogPage } from './ActivityLogList.js';
import type { ActivityProcessType, AdminAuditCategory } from '../types.js';

export function AuditLogsView() {
  const { t } = useTranslation();
  const api = useApi();

  const fetchPage = useCallback(
    (params: {
      type: ActivityProcessType | '';
      category: AdminAuditCategory | '';
      limit: number;
      offset: number;
    }): Promise<ActivityLogPage> =>
      api.logs.listMine({
        type: params.type || undefined,
        category: params.category || undefined,
        limit: params.limit,
        offset: params.offset,
      }),
    [api],
  );

  return (
    <div className="flex flex-col">
      <PageHeader
        title={t('auditLogs.pageTitle')}
        subtitle={t('auditLogs.pageSubtitle')}
        back
      />
      <div className="flex flex-col px-margin-mobile py-space-md gap-space-md">
        <ActivityLogList fetchPage={fetchPage} showTenant={false} />
      </div>
    </div>
  );
}
